'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002emath$002e$002dRounding$002dMode from "./java.math.-Rounding-Mode.js";
var $p;
/** @constructor */
function $c_Ljava_math_RoundingMode$() {
  this.IZ = null;
  this.IU = null;
  this.IT = null;
  this.rX = null;
  this.IX = null;
  this.IV = null;
  this.IW = null;
  this.IY = null;
  $n_Ljava_math_RoundingMode$ = this;
  this.IZ = new $j_java$002emath$002e$002dRounding$002dMode.$c_Ljava_math_RoundingMode("UP", 0);
  this.IU = new $j_java$002emath$002e$002dRounding$002dMode.$c_Ljava_math_RoundingMode("DOWN", 1);
  this.IT = new $j_java$002emath$002e$002dRounding$002dMode.$c_Ljava_math_RoundingMode("CEILING", 2);
  this.rX = new $j_java$002emath$002e$002dRounding$002dMode.$c_Ljava_math_RoundingMode("FLOOR", 3);
  this.IX = new $j_java$002emath$002e$002dRounding$002dMode.$c_Ljava_math_RoundingMode("HALF_UP", 4);
  this.IV = new $j_java$002emath$002e$002dRounding$002dMode.$c_Ljava_math_RoundingMode("HALF_DOWN", 5);
  this.IW = new $j_java$002emath$002e$002dRounding$002dMode.$c_Ljava_math_RoundingMode("HALF_EVEN", 6);
  this.IY = new $j_java$002emath$002e$002dRounding$002dMode.$c_Ljava_math_RoundingMode("UNNECESSARY", 7);
}
export { $c_Ljava_math_RoundingMode$ as $c_Ljava_math_RoundingMode$ };
$p = $c_Ljava_math_RoundingMode$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_math_RoundingMode$;
/** @constructor */
function $h_Ljava_math_RoundingMode$() {
}
export { $h_Ljava_math_RoundingMode$ as $h_Ljava_math_RoundingMode$ };
$h_Ljava_math_RoundingMode$.prototype = $p;
var $d_Ljava_math_RoundingMode$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_math_RoundingMode$, "java.math.RoundingMode$", ({
  kG: 1,
  a: 1
}));
export { $d_Ljava_math_RoundingMode$ as $d_Ljava_math_RoundingMode$ };
var $n_Ljava_math_RoundingMode$;
function $m_Ljava_math_RoundingMode$() {
  if ((!$n_Ljava_math_RoundingMode$)) {
    $n_Ljava_math_RoundingMode$ = new $c_Ljava_math_RoundingMode$();
  }
  return $n_Ljava_math_RoundingMode$;
}
export { $m_Ljava_math_RoundingMode$ as $m_Ljava_math_RoundingMode$ };
